"use client";

import { VenueEvents, trackEvent } from "@punchup/analytics";
import { VideoJS, VideoPlayerSurface } from "@punchup/video/client";

export function VenueVideo({
  videoId,
  venueId,
}: {
  videoId: string;
  venueId: string;
}) {
  return (
    <div className="rounded-xl overflow-hidden">
      <VideoJS
        lastPlaybackLocation={0}
        special={null}
        isPreview={false}
        surface={VideoPlayerSurface.Venue}
        poster={""}
        inline
        src={videoId}
        onPlayStatusChanged={(status: "PLAYING" | "PAUSED" | "ENDED") => {
          switch (status) {
            case "PLAYING":
              trackEvent(VenueEvents.VENUE_VIDEO_PLAYED, {
                videoId: videoId,
                venueId: venueId,
              });
              break;
            case "PAUSED":
              trackEvent(VenueEvents.VENUE_VIDEO_PAUSED, {
                videoId: videoId,
                venueId: venueId,
              });
              break;
            case "ENDED":
              trackEvent(VenueEvents.VENUE_VIDEO_ENDED, {
                videoId: videoId,
                venueId: venueId,
              });
              break;
          }
        }}
      />
    </div>
  );
}
